import Link from 'next/link';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ArticleResources = _ref => {
  let {
    heading,
    citations
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsx("h5", {
      className: styles.heading,
      children: heading || 'Resources'
    }), /*#__PURE__*/_jsx("ol", {
      children: citations.map((citation, index) => /*#__PURE__*/_jsxs("li", {
        className: styles.item,
        children: [/*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: citation.url,
          children: /*#__PURE__*/_jsx("a", {
            className: styles.resourceText,
            rel: "noopener noreferrer",
            children: citation.text
          })
        }), ", ", /*#__PURE__*/_jsx("span", {
          className: styles.resourceLink,
          children: citation.url
        })]
      }, `article-resource-${index}-${encodeURIComponent(citation.url)}`))
    })]
  });
};

export default ArticleResources;